module.exports = __webpack_public_path__ + "assets/img/beater.f1ad69d1.png";